import { Link } from "react-router-dom";
import { t } from "@/i18n/sk";

export default function NotFound() {
  return (
    <div className="vault-bg flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
      <span className="holo-text font-display text-7xl font-black">404</span>
      <h1 className="mt-4 font-display text-2xl font-bold text-white">Stránka nenájdená</h1>
      <p className="mt-2 text-slate-400">Táto stránka neexistuje alebo bola presunutá.</p>
      <Link to="/" className="btn-glow mt-8 rounded-full bg-gradient-to-r from-violet-glow to-cyan-glow px-6 py-3 text-sm font-semibold text-white">
        {t.nav.home}
      </Link>
    </div>
  );
}
